let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f9Kj8")).then(() => parcelRequire('jYtls'));